/**
 * 個人情報取り扱い同意テキスト
 *
 * web / mobile で共通利用する。
 * 将来的にはDBから取得する想定。
 */

export interface PrivacyConsentSection {
    heading: string;
    paragraphs: string[];
}

export const PRIVACY_CONSENT_TITLE = "サービス提供に伴う個人情報の利用について";

export const PRIVACY_CONSENT_INTRO =
    "統合シフト管理システム「R-Shiftサービス」（以下「本サービス」といいます）はオーエムネットワーク株式会社が提供するクラウド型SaaSサービスになります。本サービスは利用者様の個人情報を利用してサービスの提供を実施するものとなります。本サービスの利用にあたりましては下記リンク先の「個人情報の取り扱い規程」をご一読いただきまして、同意の上でご利用いただけますようお願い致します。";

export const PRIVACY_CONSENT_SECTIONS: PrivacyConsentSection[] = [
    {
        heading: "「個人情報の取り扱いについて」",
        paragraphs: [
            "オーエムネットワーク株式会社（以後、当社）が提供する「R-Shift」の利用にあたり、利用者様の個人情報を提供いただく必要がございます。以下の【取扱う個人情報に係る通知事項】をご確認いただき、本取扱いにご同意いただけた場合、サービスのご利用を開始ください。なお、当社は利用者様の在籍する企業様（以後、御社）とR-Shiftの利用契約を締結しております。",
        ],
    },
    {
        heading: "【 取扱う個人情報に係る通知事項 】",
        paragraphs: [],
    },
    {
        heading: "１．個人情報の取得と利用について",
        paragraphs: [
            "当社のR-Shiftを利用いただくにあたり、提供いただく個人情報は、以下の通りです。",
            "①氏名、②従業員コード、③メールアドレス、④生年月日、⑤性別",
            "上記の個人情報は、R-Shiftのサービスを提供するためにのみ利用いたします。",
            "なお、これ以外で利用する場合は、事前にご本人にご承認をいただくものとします。",
        ],
    },
    {
        heading: "２．第三者提供と委託について",
        paragraphs: [
            "当社は、委託業務事業者として、クラウドサーバ事業者及びメール配信サービス事業者があります。いずれの事業者も当社個人情報の保護規程により委託事業者として承認された業者のみを利用しております。\nなお、個人情報の第三者提供はいたしません。",
        ],
    },
    {
        heading: "３．個人情報の管理",
        paragraphs: [
            "当社は、取得した個人情報を適切に管理し、利用目的以外に利用せず、個人情報の漏えい、滅失又は毀損等の防止のため必要な措置を講じます。",
        ],
    },
    {
        heading: "４．個人情報の提供の任意性等について",
        paragraphs: [
            "個人情報の提供をいただくことのできない場合は、R-Shiftの一部又は全てのサービスをご利用いただけなくなることがあります。",
        ],
    },
    {
        heading: "５．欧州経済領域（ＥＥＡ）所在の方について",
        paragraphs: [
            "① 欧州経済領域（ＥＥＡ）所在の方から取得する個人情報について\n当社は、個人情報保護のため欧州経済領域（ＥＥＡ）所在の方から取得する当該個人情報については、EU一般データ保護規則（GDPR）の諸規定を遵守し取扱います。",
            "② 当社の役割\n当社は、御社との書面による契約条件に従った業務を請負い、御社の代わりに処理を行うことを目的に、個人情報の受領および取り扱いを同意した事業者で、復処理者となります。",
        ],
    },
    {
        heading: "６．個人情報の開示・訂正等のお問い合せについて",
        paragraphs: [
            "提供いただく個人情報の利用目的の通知、及び開示、訂正、追加、削除、利用または提供の拒否につきましては、下記の窓口宛にご連絡ください。本人確認手続を行ったうえで、適切に対応させていただきます。",
            "オーエムネットワーク株式会社 個人情報お問合せ担当\n所 在 地 950-0087 新潟市中央区東大通2-1-18 だいし海上ビル 6F\n電話番号 025-250-5733\n受付時間 月曜～金曜日（当社休業日を除く） 9:00～17:00",
            "なお、欧州経済領域（ＥＥＡ）所在の方は、個人情報提供者本人の居住するEEA加盟国の監督機関に対し申し立てを行うこともできます。",
        ],
    },
    {
        heading: "７．個人情報利用の同意について",
        paragraphs: [
            "提供いただく個人情報の利用に関しては、［個人情報の取り扱いに同意して、利用を開始する]をクリックいただいた時点で同意されたものといたします。",
            "なお、同意の取り消しに関しては、上記お問い合わせ先にご連絡ください。また、当社は、利用者様が退職等でR-Shiftのご利用をやめ、御社がR-Shiftから利用者様の個人情報を削除した時点においても、この同意が取り消されたこととしております。",
        ],
    },
];
